import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { filterOptionsType } from "../../../../enums/filterOptionsType";
import { filtersSelectsData } from "../FiltersData";
import MultiSelect from "./multiSelect/MultiSelect";
import classes from './FiltersSelects.module.css'

const FiltersSelects = ({ setFilters, filters }) => {

    const { coursesList } = useSelector(state => state.assessments);
    const { texts } = useSelector(state => state.translate);
    const [filtersSelectProcessed, setFiltersSelectProcessed] = useState();
    const userDetails = useSelector(state => state.auth.userDetails);

    const getUserSchool = useCallback(() => {
        if (userDetails && userDetails["schools"] && userDetails["schools"].length > 0) {
            const schoolWithClasses = userDetails["schools"].filter(x => x.fromClass)
            if (schoolWithClasses.length > 0)
                return schoolWithClasses[0]
        }
    }, [userDetails])

    const getClassRange = (from, to) => {
        const fromNum = parseInt(from, 10);
        const toNum = parseInt(to, 10);
        if (isNaN(fromNum) || isNaN(toNum)) return [];
        const range = [];
        for (let i = fromNum; i <= toNum; i++) {
            range.push(i.toString());
        }
        return range;
    }

    useEffect(() => {
        const userSchool = getUserSchool();
        const userClassesRange = userSchool ? getClassRange(userSchool.fromClass, userSchool.toClass) : [];

        let myFilterSelectes = []
        filtersSelectsData?.map((filterSelect) => {
            if (filterSelect.optionsType === filterOptionsType.fromDB) {
                const uniqueOptions = [...new Set(coursesList?.filter(course => course[filterSelect.itemField]?.trim().toLowerCase() !== "all")?.map(course => course[filterSelect.itemField]?.trim()))];
                return myFilterSelectes.push({
                    ...filterSelect,
                    options: uniqueOptions?.map(course => ({ name: course, value: course })),
                })
            }
            else {
                const optionsProcessed = filterSelect.options?.map((option) => ({ ...option, name: texts[option.name] }))
                if (filterSelect.filterName === "myclass" && userClassesRange.length > 0) {
                    const defaultSelected = optionsProcessed
                        .filter(option => option.value.some(v => userClassesRange.includes(v)))
                        .map(option => option.value);

                    return myFilterSelectes.push({
                        ...filterSelect,
                        options: optionsProcessed,
                        defaultsSelected: defaultSelected
                    });
                }
                return myFilterSelectes.push({
                    ...filterSelect,
                    options: optionsProcessed
                });
            }
        })
        setFiltersSelectProcessed(myFilterSelectes)
    }, [coursesList, texts])


    return (
        <div className={classes.FiltersSelects}>
            {filtersSelectProcessed?.map((filter, index) =>
                <MultiSelect key={index}  {...filter} setFilters={setFilters} filters={filters} />
            )}
        </div>
    )
}

export default FiltersSelects